import React from 'react'
import { useSelector } from 'react-redux'
import { APP_WHITE } from '../../constants/styles'
import useSpeechSynthesis from '../../utility/useSpeechSynthesis'
import { FaExclamationTriangle } from 'react-icons/fa'
import config from '../../config'
import { sendMessage } from '../../websockets/websocket'
import { LanguageSelector } from '../Accessibility/LanguageSelector.jsx'
import { TextToSpeechSelector } from '../Accessibility/TextToSpeechSelector.jsx'
import { CaptionSelector } from '../Accessibility/CaptionSelector.jsx'
import { getStudentId } from '../../store/stores/general'

/**
 * AccessibilitySettings - a form used to update the current student's accessibility settings
 */
export default function AccessibilitySettings(): React$Node {
	const { supported } = useSpeechSynthesis()
	const currentStudentId = useSelector(state => getStudentId(state.general))

	if (!currentStudentId) {
		return null
	}

	return (
		<div className="h-full pt-4 bg-game-primary-800 text-white px-4">
			<h2 className="text-center p-4">Accessibility</h2>
			<div className="grid grid-cols-[min-content_10em] gap-4">
				{config.useGoogleTranslate ? (
					<>
						<label htmlFor="translation-language-for-current-student">Translation</label>
						<LanguageSelector
							selectorId="translation-language-for-current-student"
							studentId={currentStudentId}
							onSelect={language => sendMessage('SET_LANGUAGE', { language })}
						/>{' '}
					</>
				) : null}
				<span className="whitespace-nowrap">Text&nbsp;To&nbsp;Speech</span>
				{supported ? (
					<TextToSpeechSelector
						studentId={currentStudentId}
						className="[&&]:w-full"
						onSelect={textToSpeech => sendMessage('SET_USE_TEXT_TO_SPEECH', { textToSpeech })}
					/>
				) : (
					<span>
						<FaExclamationTriangle color={APP_WHITE} className="inline-block mr-2" />
						Not supported
					</span>
				)}
				<span>Captions</span>
				<CaptionSelector
					studentId={currentStudentId}
					className="[&&]:w-full"
					onSelect={showCaptions => sendMessage('SET_SHOW_CAPTIONS', { showCaptions })}
				/>
			</div>
		</div>
	)
}
